export class Country {
    name:string;
    id:string;
    iso:string;

    constructor(country:any) {
        this.name = country.name;
        this.id = country.id;
        this.iso = country.iso;
    }
}